import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { StorageService } from './shared/services/storage.service';
import { BasicInterceptor } from './shared/interceptors/basic.interceptor';
import { HttpResponseInterceptor } from './shared/interceptors/http-response.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    ToastrModule.forRoot(),
    HttpClientModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BasicInterceptor,
      multi: true
  },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpResponseInterceptor,
        multi: true,
    },
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'GBP' },
    StorageService,
    DatePipe,
    provideHttpClient(),
],
})
export class AppModule { }
